import React from 'react'
import { Box } from '@mantine/core'
import { Hero, Capabilities, Portfolio, AboutMe, Contact, Skills, Opensource } from 'src/modules'

export interface HomePageProps {}

export const HomePage: React.FC<HomePageProps> = () => {
  return (
    <Box>
      <Hero />
      <Capabilities />
      <Skills />
      <Portfolio />
      <Opensource />
      <AboutMe />
      <Contact />
    </Box>
  )
}
